import React, { useEffect } from 'react';

import ActionButton from '~components/atoms/ActionButton';
import TabPageContainer from '~components/atoms/TabPageContainer';
import TabPageHeaderWrapper from '~components/atoms/TabPageHeaderWrapper';
import Text from '~components/atoms/Text';

import ProductSettingsTableSearchAndFilterBar from './ProductSettingsTableSearchAndFilterBar';
import ProductSettingsTable from './ProductSettingsTable';
import ProductSettingsTablePaginator from './ProductSettingsTablePaginator';
import ProductSettingDetailsModal from './ProductSettingDetailsModal';

import * as Styles from './_productManagementSplitSettings.module.scss';
import { useAppSelector } from '~redux/hooks';
import { ModuleEnum, PermissionsEnum } from '~utils/enums';
import ProductSettingCreateProductModal from './ProductSettingCreateProductModal';
import { useDispatch } from 'react-redux';
import combinedActions from '~redux/combinedActions';
import ProductSettingDeleteProductModal from './ProductSettingDeleteProductModal';

const SplitSettings = () => {
    const dispatch = useDispatch();

    const createAccessModules = useAppSelector(state => state.auth.userDetails.access).find(access => access.permission === PermissionsEnum.Create)?.modules || [];

    const handleCreateProductClicked = () => {
        dispatch(combinedActions.settingSetProductSettingCreateProductModalIsOpen(true));
    };

    useEffect(() => {
        dispatch(combinedActions.goldGetAllProductsAttempt());
        dispatch(combinedActions.settingGetSettingsAttempt());
    }, []);

    return (
        <TabPageContainer>
            <TabPageHeaderWrapper>
                <Text
                    label='Product List'
                    className={Styles.title}
                    isBold
                />

                {createAccessModules.find(module => module === ModuleEnum.Product)
                        && (
                            <ActionButton
                                label='Create Product'
                                onClick={handleCreateProductClicked}
                            />
                        )
                }
            </TabPageHeaderWrapper>

            <ProductSettingsTableSearchAndFilterBar />

            <ProductSettingsTable />

            <ProductSettingsTablePaginator />

            <ProductSettingDetailsModal />
            <ProductSettingCreateProductModal />
            <ProductSettingDeleteProductModal />

        </TabPageContainer>
    );
};

export default SplitSettings;
